import { Identifiable, Project } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getProjectResourcesTags(httpClient: HttpClient) {
  return (project: Identifiable<Project>) =>
    httpClient
      .sendHttpRequest<{ tags: string[] }>({
        endpoint: `/projects/${project.uuid}/members/tags`,
        method: HttpMethods.GET,
      })
      .then(({ tags }) => tags.map((name) => ({ name })));
}

export { getProjectResourcesTags };
